import React from 'react';
import { Box, Card, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isHomePage = location.pathname === '/' || location.pathname === '/home';

  // REQ-008: keep the shared footer off mobile-sized interior/app pages, but retain it on home.
  if (isMobile && !isHomePage) {
    return null;
  }

  return (
    <Card sx={{ marginTop: '30px', padding: '10px' }} data-testid="site-footer">
        <Box width={'100%'}  textAlign={'center'} >
            <Typography variant='bigPrimary_body2'>In House Property Hub</Typography>
            {/* REQ-056: provide a public entry point to the deletion request page. */}
            <Typography><Link component={RouterLink} to="/delete-account">Request account deletion</Link></Typography>
            {/* REQ-057: make the retention policy discoverable on public pages. */}
            <Typography><Link component={RouterLink} to="/data-retention-and-deletion">Data retention and deletion policy</Link></Typography>
            <Typography variant='body2' textAlign={'center'} >
                Part of the Alenzo Ltd Group<br/>
                Registered Office<br/>
                20 Wenlock Road<br/>
                London<br/>
                N1 7GU<br/>
                United Kingdom<br/>
                Company Number: 14888390<br/>
            </Typography>
        </Box>
        <Box textAlign={'right'} width={'100%'} marginTop={{xs:'25px', md: '0px'}}>
            <Typography variant='body2'>Copywrite © Alenzo™ 2023</Typography>
        </Box>
    </Card>
  );
};

export default Footer;
